import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Link,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const mailtoLink = `mailto:joseph.skinner.swe@gmail.com?subject=Message from ${form.name}&body=${form.message}%0A%0AFrom: ${form.email}`;
    window.location.href = mailtoLink;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        px: { xs: 2, md: 4 },
        py: { xs: 4, md: 8 },
        maxWidth: 'md',
        mx: 'auto',
        color: 'white',
      }}
    >
      <Typography variant="h4" gutterBottom>Contact Me</Typography>

      <Stack spacing={1.5} mb={4}>
        <Box display="flex" alignItems="center">
          <EmailIcon sx={{ mr: 1 }} />
          <Link
            href="mailto:joseph.skinner.swe@gmail.com"
            underline="hover"
            color="inherit"
          >
            joseph.skinner.swe@gmail.com
          </Link>
        </Box>

        <Box display="flex" alignItems="center">
          <PhoneIcon sx={{ mr: 1 }} />
          <Link
            href="tel:+18455001513"
            underline="hover"
            color="inherit"
          >
            +1 (845) 500-1513
          </Link>
        </Box>
      </Stack>

      <Typography mb={2} variant="h6">Let's connect  :{")"}</Typography>

      <Stack spacing={2} alignItems="center">
        <Box sx={{ width: { xs: '70%', sm: '100%' } }}>
          <TextField
            fullWidth
            label="Your Name"
            variant="outlined"
            name="name"
            onChange={handleChange}
            value={form.name}
            size="small"
            InputProps={{
              sx: {
                color: 'white',
                fontSize: { xs: '0.9rem', md: '1rem' },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#888',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#FF4C6A',
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: '#ccc',
                fontSize: { xs: '0.85rem', md: '1rem' },
              },
            }}
          />
        </Box>

        <Box sx={{ width: { xs: '70%', sm: '100%' } }}>
          <TextField
            fullWidth
            label="Your Email"
            variant="outlined"
            name="email"
            onChange={handleChange}
            value={form.email}
            size="small"
            InputProps={{
              sx: {
                color: 'white',
                fontSize: { xs: '0.9rem', md: '1rem' },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#888',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#FF4C6A',
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: '#ccc',
                fontSize: { xs: '0.85rem', md: '1rem' },
              },
            }}
          />
        </Box>

        <Box sx={{ width: { xs: '70%', sm: '100%' } }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Your Message"
            variant="outlined"
            name="message"
            onChange={handleChange}
            value={form.message}
            size="small"
            InputProps={{
              sx: {
                color: 'white',
                fontSize: { xs: '0.9rem', md: '1rem' },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#888',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#FF4C6A',
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: '#ccc',
                fontSize: { xs: '0.85rem', md: '1rem' },
              },
            }}
          />
        </Box>

        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            width: { xs: '70%', sm: "20%" },
            backgroundColor: '#5000ca',
            fontSize: { xs: '0.9rem', md: '1rem' },
            py: 1,
            px: 3,
          }}
        >
          Send
        </Button>
      </Stack>
    </Box>
  );
}

export default Contact